export default __webpack_public_path__ + "static/rovo-overlay-remix-dark-b998d50af1ce56ed5860fd1fb478e9ae.png";